import React from "react";
import Typical from "react-typical";
import "./profile.css"

export const Profile = () => {
  return (
    <div className="pContainer">
      <div className="pParent">
        <div className="pDetail">
          <div className="col">
            <div className="cIcon">
              <a href="https://github.com/gauravkrs">
                <i className="fa fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/gauravkrs/">
                <i className="fa fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/gauravkr_217/">
                <i className="fa fa-instagram"></i>
              </a>
            </div>
          </div>
          <div className="profile-name">
            <span className="ptext">
              {}
              Hello, I'M <span className="hText">Gaurav Kumar</span>
            </span>
          </div>
          <div className="pRole">
            <span className="ptext">
              {}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Dev 🔴",
                    1000,
                    "Full Stack Developer 💻",
                    1000,
                    "Mern Dev 😎",
                    1000,
                  ]}
                />
              </h1>
              <span className="pRoleT">Build  website using react node css and html.</span>
            </span>
          </div>
          <div className="pOption">
            <a href="#/">
              <button className="btn primary-btn">Contact Me</button>
            </a>
            <a href="https://bit.ly/3tfGBzv" download="gaurav.pdf" style={{marginLeft:"20px"}} target="_blank">
              <button className="btn higlighted-btn">Resume</button>
            </a>
          </div>
        </div>
        <div className="pPicture">
          <div className="pPicture-background"></div>
        </div>
      </div>
    </div>
  );
};
